export default __webpack_public_path__ + "static/media/865DE2F5-BA26-4CC8-BFEC-1693AD2DF937_1_105_c.80eca482.jpeg";